<template>
<div>
    <div v-if="dataPermission && dataPermission.includes('NSH_ORDER_VIEW')">
        <loading v-if="loading"></loading>
        <div class="page-title title">
            <span>Đơn trả hàng</span>
        </div>
        <div class="main-content-layout mb-0">
            <div class="d-flex justify-content=between mb-3">
                <b-input-group class="wrapperInput">
                    <el-popover
                        class="mr-3"
                        v-model="filterModal"
                        placement="bottom-start"
                        width="680px"
                        trigger="click">
                        <!-- reference -->
                        <el-button class="n-btn" type="info" slot="reference">
                            <div class="n-icon">
                            <i class="mdi mdi-filter-outline"></i>
                            Bộ lọc
                            </div>
                        </el-button>
                        <div class="d-flex justify-content-between">
                            <div class="filter-list">
                            <div class="w-100 my-2 d-flex">
                                <el-select
                                v-model="employeeId"
                                placeholder="Người tạo"
                                class="w-50 el mr-2">
                                <el-option
                                    v-for="item in employeeList"
                                    :key="item.index"
                                    :label="item.username"
                                    :value="item.coAliasUserId">
                                </el-option>
                                </el-select>
                                <el-select
                                v-model="customerId"
                                clearable
                                placeholder="Khách hàng"
                                class="w-50 el"
                                >
                                <el-option
                                    v-for="item in customerList"
                                    :key="item.index"
                                    :label="item.name"
                                    :value="item.coPartnerId">
                                </el-option>
                                </el-select>
                            </div>
                            <div class="w-100 my-2 d-flex">
                                <el-select
                                v-model="returnReason"
                                clearable
                                placeholder="Lý do trả hàng"
                                class="w-50 el mr-2">
                                <el-option
                                    v-for="item in reasonReturnList"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.text">
                                </el-option>
                                </el-select>
                                <el-select
                                v-model="orderStatus"
                                clearable
                                placeholder="Trạng thái đơn"
                                class="w-50 el"
                                >
                                <el-option
                                    v-for="item in processorStatus"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                                </el-select>
                            </div>
                            <div class="w-100 my-2 d-flex">
                                <el-select
                                v-model="receivedStatus"
                                clearable
                                placeholder="Trạng thái trả hàng"
                                class="w-50 el mr-2">
                                <el-option
                                    v-for="item in receivedStatusList"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                                </el-select>
                                <el-select
                                v-model="paymentStatus"
                                clearable
                                placeholder="Trạng thái hoàn tiền"
                                class="w-50 el"
                                >
                                <el-option
                                    v-for="item in paymentStatusList"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                                </el-select>
                            </div>
                            <div class="d-flex my-2 align-items-center">
                                <div class="w-25 text-right mr-2">Ngày tạo: </div>
                                <el-date-picker
                                class="el w-75"
                                type="daterange"
                                align="right"
                                start-placeholder="Từ ngày"
                                end-placeholder="Đến ngày"
                                format="dd/MM/yyyy"
                                v-model="dateRange"
                                :clearable="false">
                                </el-date-picker>
                            </div>
                            <div class="d-flex my-2 align-items-center">
                                <div class="w-25 text-right mr-2">Ngày cập nhật: </div>
                                <el-date-picker
                                class="el w-75"
                                type="daterange"
                                align="right"
                                start-placeholder="Từ ngày"
                                end-placeholder="Đến ngày"
                                format="dd/MM/yyyy"
                                v-model="dateRangeUpdate"
                                :clearable="false">
                                </el-date-picker>
                            </div>
                            </div>
                        </div>
                         <!-- list btn end filter -->
                        <div class="w-100 d-flex justify-content-end">
                            <el-button class="n-btn" @click="filterModal = false">Huỷ</el-button>
                            <el-button class="n-btn" type="danger" plain @click="removeFilter">Xóa bộ lọc</el-button>
                            <el-button class="n-btn" type="primary"  @click="() => searching(1)">Áp dụng bộ lọc</el-button>
                        </div>
                    </el-popover>
                    <div>
                        <el-input
                          v-model="search.textSearch"
                          @clear="removeTextSearch"
                          @keydown.enter.native="searching(1)"
                          placeholder="Tìm kiếm..."
                          prefix-icon="el-icon-search"
                          style="width: 280px"
                          clearable
                        >
                        </el-input>
                    </div>
                </b-input-group>
                <!-- <el-button @click="showOrdersSuccess = true" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="primary">
                    <div class="justify-content-center align-items-center d-flex">
                    <div><i style="font-size:18px; margin-right:4px" class="fa-solid fa-plus"></i></div> Thêm mới đơn trả
                    </div>
                </el-button> -->

                <!-- excel -->
                <el-button class="n-btn mx-2" v-if="downloadStorage && downloadStorage.linkDownload != ''" @click="clickCheckLinkDowload" type="info">
                    <div class="n-icon">
                    <i v-if="!isLoadLinkDownload" class="mdi mdi-export"></i>
                    <i v-else class="mdi mdi-loading mdi-spin"></i>
                    Tải dữ liệu
                    </div>
                </el-button>
                <el-button class="n-btn mx-2" v-else :disabled="isLoadLinkDownload"  @click="clickExportData" type="info">
                    <div class="n-icon">
                    <i v-if="!isLoadLinkDownload" class="mdi mdi-export"></i>
                    <i v-else class="mdi mdi-loading mdi-spin"></i>
                    Xuất dữ liệu
                    </div>
                </el-button>
                <!-- export theo chi tiet don -->
               <el-button class="n-btn mx-2" v-if="downloadStorage2 && downloadStorage2.linkDownload != ''" @click="clickCheckLinkDowload2" type="info">
                   <div class="n-icon">
                   <i v-if="!isLoadLinkDownload2" class="mdi mdi-export"></i>
                   <i v-else class="mdi mdi-loading mdi-spin"></i>
                   Tải chi tiết đơn
                   </div>
               </el-button>
               <el-button class="n-btn mx-2" v-else :disabled="isLoadLinkDownload2"  @click="clickExportData2" type="info">
                   <div class="n-icon">
                   <i v-if="!isLoadLinkDownload2" class="mdi mdi-export"></i>
                   <i v-else class="mdi mdi-loading mdi-spin"></i>
                   Xuất chi tiết đơn
                   </div>
               </el-button>
                <el-button @click="showOrdersSuccess = true" class="n-btn" type="primary">
                    <div class="n-icon">
                    <i class="mdi mdi-plus"></i>
                    Thêm mới đơn trả
                    </div>
                </el-button>
            </div>
            <div style="max-width: 100%; width: 100%">
                <b-table 
                    class="n-table" head-variant="light" :items="dataItems" :fields="fieldTable.filter(e => e.show)">
                    <template #table-caption>
                        <div v-if="dataItems.length === 0">
                            <div class="text-center mt-5 mb-5 empty-return-table">
                                <div><img src="@/assets/images/return-order-empty.png" /></div>
                                    <h3>Bạn chưa có đơn trả hàng nào</h3>
                            </div>
                        </div>
                    </template>
                    
                    <template #head(edit)>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer" @click="showPopup('Cai-dat-hien-thi'), (visibleEditShow = true)">
                            <path d="M6.16016 9.50391C6.85449 9.50391 7.4082 8.9502 7.4082 8.25586C7.4082 7.57031 6.85449 7.00781 6.16016 7.00781C5.47461 7.00781 4.91211 7.57031 4.91211 8.25586C4.91211 8.9502 5.47461 9.50391 6.16016 9.50391ZM10.291 9.09961H22.2266C22.7012 9.09961 23.0791 8.73047 23.0791 8.25586C23.0791 7.78125 22.71 7.41211 22.2266 7.41211H10.291C9.8252 7.41211 9.44727 7.78125 9.44727 8.25586C9.44727 8.73047 9.81641 9.09961 10.291 9.09961ZM6.16016 14.9092C6.85449 14.9092 7.4082 14.3555 7.4082 13.6611C7.4082 12.9756 6.85449 12.4131 6.16016 12.4131C5.47461 12.4131 4.91211 12.9756 4.91211 13.6611C4.91211 14.3555 5.47461 14.9092 6.16016 14.9092ZM10.291 14.5049H22.2266C22.7012 14.5049 23.0791 14.1357 23.0791 13.6611C23.0791 13.1865 22.71 12.8174 22.2266 12.8174H10.291C9.8252 12.8174 9.44727 13.1865 9.44727 13.6611C9.44727 14.1357 9.81641 14.5049 10.291 14.5049ZM6.16016 20.3145C6.85449 20.3145 7.4082 19.7607 7.4082 19.0664C7.4082 18.3809 6.85449 17.8184 6.16016 17.8184C5.47461 17.8184 4.91211 18.3809 4.91211 19.0664C4.91211 19.7607 5.47461 20.3145 6.16016 20.3145ZM10.291 19.9102H22.2266C22.7012 19.9102 23.0791 19.541 23.0791 19.0664C23.0791 18.5918 22.71 18.2227 22.2266 18.2227H10.291C9.8252 18.2227 9.44727 18.5918 9.44727 19.0664C9.44727 19.541 9.81641 19.9102 10.291 19.9102Z" fill="#888888"/>
                        </svg>
                    </template>
                    <template #cell(soOrderNo)="data">
                        <span v-if="!(data.item.processorStatus == 'CANCEL')" @click="linkTo(data.item.id)" style="cursor: pointer">
                            {{data.item.soOrderNo}}
                        </span>
                        <span v-else>
                            {{data.item.soOrderNo}}
                        </span>
                    </template>
                    <template #cell(orderNo)="data">
                        {{data.item.orderNo}}
                    </template>
                    <template #cell(totalPaidAmount)="data">
                        {{ formatMoneyNotUnit(Math.floor(data.item.lineItemFinalizing.finalAmount / 1000)) }}
                    </template>
                    <template #cell(processorStatusText)="data">
                        <base-tag :type="data.item.processorStatusDisplay.color">{{ data.item.processorStatusDisplay.text }}</base-tag> 
                    </template>
                    <template #cell(edit)="data">
                        <IconEditRecord
                            v-if="!((data.item.processorStatus == 'CANCEL') || (data.item.processorStatus == 'COMPLETE'))"
                            :options="optionsEditShow(data.item.furtherInstructions[0].params.isReceivedItem, data.item.furtherInstructions[0].params.paymentStatus, data.item.furtherInstructions[0].params.isExchanged, data.item.furtherInstructions[0].params.refundType)"
                            @select="chooseOption($event, data.item)"
                        />
                    </template>
                    <template #cell(returnReason)="data">
                        {{data.item.furtherInstructions[0].params.returnReason}}
                    </template>
                    <template #cell(isReceivedItem)="data">
                        <base-box-is-fill :isFilled="data.item.furtherInstructions[0].params.isReceivedItem"/>
                    </template>
                    <template #cell(paymentStatus)="data">
                        <base-payment-status :status="data.item.furtherInstructions[0].params.paymentStatus"/>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    class="bottom-pagination"
                ></b-pagination>
            </div>
            <ItemArrangeColumn v-model="fieldTable" />
        </div>
        <el-dialog top="2vh" custom-class="orders-success" title="Chọn đơn mua để trả hàng" :visible.sync="showOrdersSuccess" width="960px" @before-close="showOrdersSuccess = false">
            <OrdersReturnAll @closeModal="showOrdersSuccess = false" ></OrdersReturnAll>
        </el-dialog>

        <el-dialog
            append-to-body
            :visible.sync="cancelModal"
            :title="'Hủy đơn trả hàng'"
            width="600px"
            :close-on-click-modal="false"
        >
            <div class="text-align-center" style="margin-top:30px">
                <IconCancel />
                <p style="margin-top: 10px;">Bạn có xác nhận huỷ đơn trả hàng này?</p>
            </div>
            <template slot="footer">
                <el-button type="text" @click="cancelModal = false">Quay lại</el-button>
                <b-overlay
                    :show="busy"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block loading-btn"
                >
                    <el-button
                            type="danger"
                            :disabled="busy"
                            @click="btnConfirmDelOrder"
                    >
                        Hủy đơn
                    </el-button>
                </b-overlay>
            </template>
        </el-dialog>

        <el-dialog append-to-body :visible.sync="receivedModal" :title="'Xác nhận đã nhận hàng trả'" width="600px" :close-on-click-modal="false">
            <div class="text-align-center" style="margin-top:30px">
                <IconSuccess />
                <p style="margin-top: 10px;">
                    Xác nhận đã nhận được hàng trả?
                </p>
            </div>
            <template slot='footer'>
                <el-button type='text' @click="receivedModal = false">Quay lại</el-button>
                <b-overlay
                    :show="busy"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block loading-btn"
                >
                    <el-button type='primary' :disabled="busy" @click="btnConfirmReceiveOrder">
                        Xác nhận
                    </el-button>
                </b-overlay>
            </template>
        </el-dialog>

        <el-dialog append-to-body :visible.sync="paymentModal" :title="'Hoàn tiền cho khách'" width="800px" :close-on-click-modal="false">
                <p style="color: #23313E;width: 560px;height: 20px;font-weight: 600;font-size: 16px;line-height: 20px;">Thông tin hoàn tiền</p>
                    <div class="payment-info"> 
                        <div class="row px-3 d-flex justify-content-between">
                            <span>Tổng phải hoàn</span>
                            <span>{{this.formatMoneyNotUnit(this.paymentInfo.finalAmount)}}</span>
                        </div>
                        <div class="row px-3 d-flex justify-content-between">
                            <span>Đã hoàn</span>
                            <span>{{this.formatMoneyNotUnit(this.paymentInfo.totalPaidAmount)}}</span>
                        </div>
                        <div class="row px-3 d-flex justify-content-between total-paid-amount-left">
                            <span>Còn lại phải hoàn</span>
                            <span>{{this.formatMoneyNotUnit(this.paymentInfo.totalPaidAmountLeft)}}</span>
                        </div>
                    </div>
            <div class="payment-status">
                <div>
                    <div
                        style="display:flex;flex-direction:column"
                    >
                        <span>Phương thức thanh toán</span>
                        <el-select
                            v-model="payMethod"
                            placeholder="Chọn phương thức"
                            class="el">
                                <el-option
                                    v-for="item in payMethodList"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                        </el-select>
                    </div>
                </div>
                <div>
                    <span>Số tiền hoàn</span>
                    <el-input 
                        v-model="amount" 
                        @input="inputMoney(), checkMaxValue(amount, paymentInfo.totalPaidAmountLeft)"
                        clearable
                        placeholder="0"
                    />
                </div>
                <div>
                    <span>Mã tham chiếu</span>
                    <el-input
                        v-model="gatewayTransactionId"
                        maxlength="50"
                        clearable
                        placeholder="Nhập mã"
                    />
                </div>
            </div>
            <template slot='footer'>
                <el-button type='text' @click="paymentModal = false">Thoát</el-button>
                <b-overlay
                    :show="busy"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block loading-btn"
                >
                    <el-button type="primary" v-if="this.amount == 0 || this.payMethod == ''" disabled>Thêm</el-button>
                    <el-button type='primary' :disabled="busy" @click="btnChangePaymentStatus" v-else>
                        Thêm
                    </el-button>
                </b-overlay>
            </template>
        </el-dialog>

        <el-dialog append-to-body :visible.sync="CustomerPayModal" :title="'Khách thanh toán'" width="800px" :close-on-click-modal="false">
            <p style="color: #23313E;width: 560px;height: 20px;font-weight: 600;font-size: 16px;line-height: 20px;">Thông tin thanh toán</p>
            <div class="payment-info"> 
                <div class="row px-3 d-flex justify-content-between">
                    <span>Khách phải trả</span>
                    <span>{{this.formatMoneyNotUnit(this.paymentInfo.finalAmount)}}</span>
                </div>
                <div class="row px-3 d-flex justify-content-between">
                    <span>Đã trả</span>
                    <span>{{this.formatMoneyNotUnit(this.paymentInfo.totalPaidAmount)}}</span>
                </div>
                <div class="row px-3 d-flex justify-content-between total-paid-amount-left">
                    <span>Còn lại cần thanh toán</span>
                    <span>{{this.formatMoneyNotUnit(this.paymentInfo.totalPaidAmountLeft)}}</span>
                </div>
            </div>
            <div class="payment-status">
                <div>
                    <div
                        style="display:flex;flex-direction:column"
                    >
                        <span>Phương thức thanh toán</span>
                        <el-select
                            v-model="payMethod"
                            placeholder="Chọn phương thức"
                            class="el">
                                <el-option
                                    v-for="(payMethod, index) in customerPayMethodList"
                                    :key="index"
                                    :label="payMethod.text"
                                    :value="payMethod.value">
                                </el-option>
                        </el-select>
                    </div>
                </div>
                <div>
                    <span>Số tiền thanh toán</span>
                    <el-input
                        v-model="amount"
                        @input="inputMoney(), checkMaxValue(amount, paymentInfo.totalPaidAmountLeft)"
                        clearable
                        placeholder="0"
                    />
                </div>
                <div>
                    <span>Mã tham chiếu</span>
                    <el-input 
                        v-model="gatewayTransactionId" 
                        maxlength="50"
                        clearable
                        placeholder="Nhập mã"
                    />
                </div>
            </div>
            <template slot='footer'>
                <el-button type='text' @click="CustomerPayModal = false">Thoát</el-button>
                <b-overlay
                    :show="busy"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block loading-btn"
                >
                    <el-button type="primary" v-if="this.amount == 0 || this.payMethod == ''" disabled>Thêm</el-button>
                    <el-button type='primary' :disabled="busy" @click="updatePaymentItemHaveExchange(amount, payMethod)" v-else>
                        Thêm
                    </el-button>
                </b-overlay>
            </template>
        </el-dialog>

        <el-dialog append-to-body :visible.sync="MerchantPayModal" :title="'Hoàn tiền cho khách'" width="800px" :close-on-click-modal="false">
            <p style="color: #23313E;width: 560px;height: 20px;font-weight: 600;font-size: 16px;line-height: 20px;">Thông tin hoàn tiền</p>
                <div class="payment-info"> 
                    <div class="row px-3 d-flex justify-content-between">
                        <span>Tổng phải hoàn</span>
                        <span>{{this.formatMoneyNotUnit(this.paymentInfo.finalAmount)}}</span>
                    </div>
                    <div class="row px-3 d-flex justify-content-between">
                        <span>Đã hoàn</span>
                        <span>{{this.formatMoneyNotUnit(this.paymentInfo.totalPaidAmount)}}</span>
                    </div>
                    <div class="row px-3 d-flex justify-content-between total-paid-amount-left">
                        <span>Còn lại phải hoàn</span>
                        <span>{{this.formatMoneyNotUnit(this.paymentInfo.totalPaidAmountLeft)}}</span>
                    </div>
                </div>
        <div class="payment-status">
                <div>
                    <div
                        style="display:flex;flex-direction:column"
                    >
                        <span>Phương thức thanh toán</span>
                        <el-select
                            v-model="payMethod"
                            placeholder="Chọn phương thức"
                            class="el">
                                <el-option
                                    v-for="item in payMethodList"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                        </el-select>
                    </div>
                </div>
                <div>
                    <span>Số tiền hoàn</span>
                    <el-input 
                        v-model="amount" 
                        @input="inputMoney(), checkMaxValue(amount, paymentInfo.totalPaidAmountLeft)"
                        clearable
                        placeholder="0"
                    />
                </div>
                <div>
                    <span>Mã tham chiếu</span>
                    <el-input 
                        v-model="gatewayTransactionId" 
                        maxlength="50"
                        clearable
                        placeholder="Nhập mã"
                    />
                </div>
            </div>
            <template slot='footer'>
                <el-button type='text' @click="MerchantPayModal = false">Thoát</el-button>
                <b-overlay
                    :show="busy"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block loading-btn"
                >
                    <el-button type="primary" v-if="this.amount == 0 || this.payMethod == ''" disabled>Thêm</el-button>
                    <el-button type='primary' :disabled="busy" @click="updatePaymentItemHaveExchange(amount, payMethod)" v-else>
                        Thêm
                    </el-button>
                </b-overlay>
            </template>
        </el-dialog>
    </div>
    <NotPermission v-else></NotPermission>
</div>
</template>

<script>
import VueCookies from 'vue-cookies'
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";
import { OrdersService } from "@/services/nextshop/orders.service";
import { EmployeeService } from '@/services/nextshop/employee.service';
import { CustomerServices } from "@/services/nextshop/customer.service";
import { formatHHmmDDMMYYYY } from "../../utils/format";
import { OrderReturnStatus } from "../../utils/mapping";
import OrdersReturnAll from './components/orders-return-all.vue';
import IconSuccess from '@/components/icons/icon_success.vue';
import IconCancel from "@/components/icons/icon_cancel.vue";
import {
  getLocationID
} from "../../utils/auth";
import moment from "moment";
import Swal from "sweetalert2";
import exportExcel from "@/mixins/exportExcel/index.js"
import copyExport from "@/mixins/exportExcel/copyExport.js"



export default {
    name: "order-return",
    components: {
        ItemArrangeColumn,
        OrdersReturnAll,
        IconSuccess,
        IconCancel
    },
    mixins: [
        exportExcel,
        copyExport
    ],
    data() {
        return {
            dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
            locationId: VueCookies.get("LID"),
            loading: false,
            filterModal: false,
            paymentModal: false,
            receivedModal: false,
            cancelModal: false,
            CustomerPayModal: false,
            MerchantPayModal: false,
            textSearch: '',
            currentPage: 1,
            pageNum: "1",
            customerList: [],
            employeeList: [],
            dataItems: [],
            gatewayTransactionId: '',
            fieldTable: [
                {
                    label: "Mã đơn mua",
                    key: "soOrderNo",
                    show: true,
                },
                {
                    label: "Mã đơn trả",
                    key: "orderNo",
                    show: true
                },
                {
                    label: "Khách hàng",
                    key: "customerName",
                    show: true
                },
                {
                    label: "Trạng thái đơn",
                    key: "processorStatusText",
                    show: true,
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: "Tổng phải hoàn",
                    key: "totalPaidAmount",
                    show: true,
                    thClass: "text-right",
                    tdClass: "text-right",
                },
                {
                    label: "Hoàn tiền",
                    key: "paymentStatus",
                    show: true,
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: "Nhận hàng trả",
                    key: "isReceivedItem",
                    show: true,
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: "Lý do trả hàng",
                    key: "returnReason",
                    show: false
                },
                {
                    label: "Người tạo đơn",
                    key: "soEmployeeName",
                    show: false
                },
                {
                    label: "Nhân viên thực hiện",
                    key: "seller",
                    show: false
                },
                {
                    label: "Thời gian cập nhập",
                    key: "updatedAt",
                    show: false
                },
                {
                    label: "Ngày tạo đơn",
                    key: "createdAt",
                    show: true
                },
                {
                    label: "",
                    key: "edit",
                    show: true,
                    thStyle: { width: "5%", 'min-width': "50px" },
                    thClass: "text-center",
                    tdClass: "text-center",
                }
            ],
            processorStatus: [
                { id: "DRAFT", text: "Đang tiến hành", value: 'DRAFT' },
                { id: "COMPLETE", text: "Hoàn thành", value: 'COMPLETE' },
                { id: "CANCEL", text: "Đã hủy", value: 'CANCEL' },
            ],
            searchText: false,
            employeeId: '',
            customerId: '',
            orderStatus: '',
            returnReason: '',
            paymentStatus: '',
            receivedStatus: '',
            dateRange: {},
            dateRangeUpdate: {},
            reasonReturnList: [
                {
                    id:1,
                    text: 'Hàng hỏng'
                },
                {
                    id:2,
                    text: 'Thu hồi hàng lỗi'
                },
                {
                    id:3,
                    text: 'Khách muốn đổi trả'
                },
                {
                    id:4,
                    text: 'Hàng hết hạn'
                },
                {
                    id:5,
                    text: 'Khác'
                },
            ],
            lineInfo: {},
            receivedStatusList: [
                {
                    id:1,
                    text: 'Chưa nhận hàng trả',
                    value: 'false'
                },
                {
                    id:2,
                    text: 'Đã nhận hàng trả',
                    value: 'true'
                }
            ],
            payMethod: "",
            payMethodList: [
                {
                    id: 1,
                    text: "Tiền mặt",
                    value: "CASH"
                },
                {
                    id: 2,
                    text: "Chuyển khoản",
                    value: "BANK"
                }
            ],
            
            customerPayMethodList: [
                {
                text: "Tiền mặt",
                value: "CASH",
                },
                {
                text: "Chuyển khoản",
                value: "BANK_TRANSFER",
                },
                {
                text: "Quẹt thẻ",
                value: "SWIPE",
                },
                {
                text: "MPOS",
                value: "MPOS",
                }
            ],

            amount: 0,
            busy: false,
            paymentStatusList: [
                {
                    id:1,
                    text: 'Chưa hoàn tiền',
                    value: 'UNPAID'
                },
                {
                    id:2,
                    text: 'Hoàn tiền một phần',
                    value: 'PAYING'
                },
                {
                    id:3,
                    text: 'Đã hoàn đủ',
                    value: 'PAID_IN_FULL'
                }
            ],
            search: {
                queryString: "",
                sortBy: "createdAt",
                sortType: "DESC",
                pageNum: "1",
                pageSize: "20",
                textSearch: ""
            },
            rows: 450,
            coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
            LID: getLocationID(),
            listInventory: [],
            paymentInfo: {
                totalPaidAmount: 0,
                finalAmount: 0,
                totalPaidAmountLeft: 0
            },
            paymentInfoList: [
                {
                    label: "finalAmount",
                    key: "finalAmount",
                },
                {
                    label: "totalPaidAmount",
                    key: "totalPaidAmount",
                },
                {
                    label: "totalPaidAmountLeft",
                    key: "totalPaidAmountLeft",
                }
            ],
            showOrdersSuccess: false,
            // excelStoge
            localStorageKeyFordownloadStorage: "downloadStorage_return_order",
            localStorageKeyFordownloadStorage2: "downloadStorage_return_order_2",
        }
    },
    

    async created() {
        await Promise.all[ this.getListEmployee(),  this.getListCustomer(), this.searching()]
    },

    watch: {
        currentPage() {
            this.searching(this.currentPage)
        },
        "search.textSearch": _.debounce(function() {
            if (this.search.textSearch == "") this.searching(1);
        },700)
    },

    methods: {
        async getListOrdersReturn(params) {
            this.dataItems = [];
            try {
                this.loading = true;
                const response = await OrdersService.getListOrdersReturn(params);
                this.loading = false
                if (response.success) {
                    this.rows = response.data.totalElements;
                    response.data.data.map((res) => {
                        const { partyB, partyA, furtherInstructions } = res;
                        if (res.processorStatus == "DRAFT") {
                            res.processorStatus = "PROCESSING"
                        }
                        const tmp =  {
                           ...res,
                            orderNo : res.orderNo,
                            soOrderNo: furtherInstructions[0].params.soOrderNo,
                            seller: partyA.displayName,
                            customerName: partyB.displayName,
                            returnReason: furtherInstructions[0].params > 0 ? furtherInstructions[0].params.returnReason : "",
                            totalPaidAmount: furtherInstructions[0].params > 0 ? furtherInstructions[0].params.totalPaidAmount : "",
                            isReceivedItem: furtherInstructions[0].params > 0 ? furtherInstructions[0].params.isReceivedItem : "",
                            paymentStatus: furtherInstructions[0].params > 0 ? furtherInstructions[0].params.paymentStatus: "",
                            processorStatusText: OrderReturnStatus(res.processorStatus).text,
                            processorStatusDisplay: OrderReturnStatus(res.processorStatus),
                            soEmployeeName: furtherInstructions[0].params.soEmployeeName,
                            createdAt: formatHHmmDDMMYYYY(res.createdAt),
                            updatedAt: formatHHmmDDMMYYYY(res.updatedAt),
                        };
                        this.dataItems.push(tmp)
                    });
                } 
            } catch (error) {
                this.loading = false
            }
        },

        async getListEmployee() {
            this.employeeList = []
            const params = {
                merchantId: this.coMerchantId,
                locationId: this.LID,
                userType: JSON.parse(localStorage.getItem("auth.currentUser")).role
            }
            try {
                const response = await EmployeeService.listEmployeeLocation(params)
                if (response.success) {
                    if(response.data.length != 0) {
                        for (let employee of response.data) {
                            this.employeeList.push(employee)
                        }
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },

        async getListCustomer () {
            const params = {
                query: "",
                merchantId: JSON.parse(localStorage.getItem("auth.currentUser")).merchantId,
                person: 2,
                sort: "date",
            };
            try {
                const response = await CustomerServices.getListCustomer(params);
                if (response.success) {
                    if(response.data.length != 0) {
                        for (let customer of response.data) {
                            this.customerList.push(customer);
                        }
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },

        async searching(page) {
            this.searchText = true;
            if (page) {
                this.currentPage = page
                this.search.pageNum = page
            }
            const queryArray = [];

            // get locationId
            queryArray.push("{locationToCreate} == '''" + this.locationId + "'''");

            if (this.employeeId != "") {
                queryArray.push(`{furtherInstructions.params.employeeId} == '''${this.employeeId}'''`)
            }
            if (this.customerId != "") {
                queryArray.push(`{furtherInstructions.params.customerId} == '''${this.customerId}'''`)
            }
            if (this.returnReason != "") {
                queryArray.push(`{furtherInstructions.params.returnReason} == '''${this.returnReason}'''`)
            }
            if (this.orderStatus != "") {
                queryArray.push(`{processorStatus} == '''${this.orderStatus}'''`)
            }
            if (this.receivedStatus != "") {
                queryArray.push(`{furtherInstructions.params.isReceivedItem} == '''${this.receivedStatus}'''`)
            }
            if (this.paymentStatus != "") {
                queryArray.push(`{furtherInstructions.params.paymentStatus} == '''${this.paymentStatus}'''`)
            }
            if (this.dateRange[0] != undefined || this.dateRange[1] != undefined) {
                queryArray.push(
                "{createdAt} >= #" +
                    `${moment(this.dateRange[0]).format("YYYY-MM-DD")}` +
                    `T00:00:00.000Z# and {createdAt} <= #` +
                    `${moment(this.dateRange[1]).format("YYYY-MM-DD")}` +
                    "T23:59:59.000Z#"
                );
            }
            if (
                this.dateRangeUpdate[0] != undefined ||
                this.dateRangeUpdate[1] != undefined
            ) {
                queryArray.push(
                "{updatedAt} >= #" +
                    `${moment(this.dateRangeUpdate[0]).format("YYYY-MM-DD")}` +
                    `T00:00:00.000Z# and {updatedAt} <= #` +
                    `${moment(this.dateRangeUpdate[1]).format("YYYY-MM-DD")}` +
                    "T23:59:59.000Z#"
                );
            }
            if (queryArray.length > 0) {
                this.search.queryString = queryArray.join(" and ") + " and {orderType} == '''RO'''";
            } else {
                this.search.queryString = "{orderType} == '''RO'''";
            }
            this.search.textSearch = this.search.textSearch.trim()
            this.filterModal = false;
            await this.getListOrdersReturn(this.search);
            // this.search.queryString = '' ??? why
        },

        hideIcon() {
            return this.search.textSearch.length != 0;
        },

        async removeFilter() {
            this.employeeId = "";
            this.customerId = "";
            this.orderStatus = "";
            this.paymentStatus = "";
            this.receivedStatus = "";
            this.returnReason = "";
            this.dateRange = {};
            this.dateRangeUpdate = {};
            this.filterModal = false;
            this.search = {
                queryString: "",
                sortBy: "createdAt",
                sortType: "DESC",
                pageNum: "1",
                pageSize: "20",
                textSearch: this.search.textSearch
            }
            this.searchText = true;
            this.searching()
        },

        async removeTextSearch() {
            this.search.textSearch = "";
            // await this.getListOrdersReturn(this.search);
            this.searching()
        },

        optionsEditShow(isReceivedItem, paymentStatus, isExchanged, refundType) {
            let renderCase = []
            let option1 = { id: 1, text: "Nhận hàng trả", color: "secondary" };
            let option2 = { id: 2, text: "Xác nhận Thanh toán", color: "secondary" };
            let option3 = { id: 3, text: "Hủy đơn", color: "danger" };

            if ( isReceivedItem == 'false' ) {
                renderCase.push(option1);
                if ( paymentStatus == "UNPAID" || paymentStatus == "PAYING" || paymentStatus == "CUSTOMER_PAYING" || paymentStatus == "CUSTOMER_UNPAID") {
                    renderCase.push(option2)
                    if ( paymentStatus == "UNPAID" || paymentStatus == "CUSTOMER_UNPAID" ) {
                        if (isExchanged == 'true') {
                            if (refundType == "CUSTOMER_PAY") {
                                renderCase.push(option3)
                            }
                        } else {
                            renderCase.push(option3)
                        }
                    }
                }
            } else if ( isReceivedItem == 'true' ) {
                if ( paymentStatus == "UNPAID" || paymentStatus == "PAYING" || paymentStatus == "CUSTOMER_PAYING" || paymentStatus == "CUSTOMER_UNPAID" ) {
                    renderCase.push(option2)
                }
            }
            return renderCase;
        },

        async chooseOption(data, item) {
            this.paymentInfo =
                {
                    totalPaidAmount: item.furtherInstructions[0].params.totalPaidAmount / 1000,
                    finalAmount: item.lineItemFinalizing.finalAmount / 1000,
                    totalPaidAmountLeft: (item.lineItemFinalizing.finalAmount / 1000) - (item.furtherInstructions[0].params.totalPaidAmount / 1000)
                }
            this.lineInfo = item
            switch (data) {
                case "Xác nhận Thanh toán" :
                    if(item.furtherInstructions[0].params.isExchanged == 'true') {
                        let itemHaveExchangeId = item.furtherInstructions[0].params.exchangeOrderId
                        let returnPrice = item.lineItemFinalizing.finalAmount 
                        await this.checkHaveExchangeItem(itemHaveExchangeId, returnPrice);
                    } else {
                        this.paymentModal = true;
                    }
                    break;
                case "Nhận hàng trả" :
                    this.receivedModal = true;
                    break;
                case "Hủy đơn" :
                    this.cancelModal = true
            }
        },

        async checkHaveExchangeItem(id, price) {
            this.loading = true
          const res = await OrdersService.getOrderById(id);
          if (res.success && res.data.id != "") {
              if(res.data.lineItemFinalizing.finalAmount - price > 0) {
                this.CustomerPayModal = true;
                this.paymentInfo.finalAmount = (res.data.lineItemFinalizing.finalAmount - price) / 1000
                this.paymentInfo.totalPaidAmountLeft = (this.paymentInfo.finalAmount - this.paymentInfo.totalPaidAmount)
              } else if (res.data.lineItemFinalizing.finalAmount - price < 0) {
                this.MerchantPayModal = true;
                this.paymentInfo.finalAmount = (price - res.data.lineItemFinalizing.finalAmount) / 1000
                this.paymentInfo.totalPaidAmountLeft = (this.paymentInfo.finalAmount - this.paymentInfo.totalPaidAmount)
              }
          }
          this.loading = false
        },

        async btnConfirmDelOrder() {
            this.busy = true
            try {
                const response = await OrdersService.delOrderReturn({"returnOrderId" : `${this.lineInfo.id}`})
                if (response.success) {
                    this.cancelModal = false;
                    this.modalSuccess('delOrder')
                    this.getListOrdersReturn(this.search);
                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false
        },

        async btnConfirmReceiveOrder() {
            this.busy = true;
            try {
                const response = await OrdersService.updateOrderReturn({"orderId": this.lineInfo.id,"isReceivedItem" : true})
                if (response.success) {
                    this.receivedModal = false;
                    this.modalSuccess('receivedStatus');
                    this.getListOrdersReturn(this.search);
                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },

        async btnChangePaymentStatus() {
            this.busy = true;
            if (this.payMethod == "CASH") {
                let param = {
                    orderId: this.lineInfo.id,
                    paymentList: [
                        {
                            amount: this.checkNumReplaceComma(this.amount) * 1000,
                            isNew: true,
                            paymentGateway: "CASH",
                            paymentMethod: "CASH",
                            status: "SUCCESS",
                            gatewayTransactionId: this.gatewayTransactionId,
                        }
                    ]
                }
                try {
                    const response = await OrdersService.updateOrderReturn(param)
                    if (response.success) {
                        this.paymentModal = false;
                        this.modalSuccess('');
                        this.getListOrdersReturn(this.search);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else if (this.payMethod == "BANK") {
                let param = {
                    orderId: this.lineInfo.id,
                    paymentList: [
                        {
                            amount: this.checkNumReplaceComma(this.amount) * 1000,
                            isNew: true,
                            paymentGateway: "BANK",
                            paymentMethod: "BANK_TRANSFER",
                            status: "SUCCESS",
                            gatewayTransactionId: this.gatewayTransactionId,
                        }
                    ]
                }
                try {
                    const response = await OrdersService.updateOrderReturn(param)
                    if (response.success) {
                        this.paymentModal = false;
                        this.modalSuccess('');
                        this.getListOrdersReturn(this.search);
                    }
                } catch (error) {
                    console.log(error);
                }
            }
            
            this.busy = false;
            this.payMethod = "";
            this.amount = 0;
            this.gatewayTransactionId = ""
        },

        async updatePaymentItemHaveExchange(amount, method) { 
            this.loading = true
            this.busy = true;
            let param = {
                orderId: this.lineInfo.id,
                paymentList: [
                    {
                    amount: this.checkNumReplaceComma(amount) * 1000,
                    isNew: true,
                    paymentGateway: "NEXT_SHOP",
                    paymentMethod:  method,
                    status: "SUCCESS",
                    gatewayTransactionId: this.gatewayTransactionId
                    },
                ]
            }
            if(method == "SWIPE") {
                param.paymentList[0].paymentGateway = "OTHER"
            } else if (method == "MPOS") {
                param.paymentList[0].paymentGateway = method
                param.paymentList[0].paymentMethod = 'SWIPE'
            }
            try {
                const response = await OrdersService.updateExchangeReturnOrder(param)
                if (response.success) {
                this.CustomerPayModal = false;
                this.MerchantPayModal = false;
                Swal.fire({
                    icon: 'success',
                    title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
                    html:'<span style="color:#9093A4; font-size: 14px;" >Hoàn tiền cho khách thành công</span>',
                    confirmButtonText: "Xác nhận",
                }).then(()=>{
                    this.getListOrdersReturn(this.search);
                })
                }
            } catch (error) {
                console.log(error);
            }
            this.loading = false
            this.busy = false
            this.gatewayTransactionId = ''
            this.amount = 0
            this.payMethod = ''
        },

        modalSuccess(type){
            if (type == 'receivedStatus') {
                Swal.fire({
                    icon: 'success',
                    title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
                    html:'<span style="color:#9093A4; font-size: 14px;" >Xác nhận đã nhận được hàng trả thành công</span>',
                    confirmButtonText: "Xác nhận",
                }).then(()=>{
                    this.$router.push({path: '/orders/orders-return'})
                })
            }
            else if (type == 'delOrder') {
                Swal.fire({
                    icon: 'success',
                    title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
                    html:'<span style="color:#9093A4; font-size: 14px;" >Xóa đơn trả hàng thành công</span>',
                    confirmButtonText: "Xác nhận",
                }).then(()=>{
                    this.$router.push({path: '/orders/orders-return'})
                })
            } else {
                Swal.fire({
                    icon: 'success',
                    title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
                    html:'<span style="color:#9093A4; font-size: 14px;" >Hoàn tiền cho khách thành công</span>',
                    confirmButtonText: "Xác nhận",
                }).then(()=>{
                    this.$router.push({path: '/orders/orders-return'})
                })
            }
        },

        inputMoney() {
            this.amount = this.formatMoneyNotUnit(this.amount)
        },

        linkTo(id) {
            this.$router.push({ path: `/orders-return/detail/${id}`})
        },

        checkMaxValue(val,maxValue) {
            if ( this.checkNumReplaceComma(val) > maxValue) {
                this.amount = this.formatMoneyNotUnit(maxValue)
            }
        },
         // xuat excel
        async clickExportData() {
        try {
            this.isLoadLinkDownload = true
            const params = {
            "isOnlyReturnable": false,
            "lastIndex": "",
            "queryString": this.search.queryString,
            "limit": 5000,
            "textSearch": this.search.textSearch,
            }
            // console.log("params:::", params, this.search);
            // this.isLoadLinkDownload = false
            // return
            const response = await OrdersService.exportDataRO(params)
            console.log("data:::", response);
            if(response.success){
            this.clickExportDataMixin(response.data, '/nsh/iex/api/order/download-file/')
            } else {
            this.$message.warning('Máy chủ đang bận. Hãy thử lại sau. ')
            }
        } catch (error) {
            this.$message.warning('Máy chủ đang bận. Hãy thử lại sau. '+ error)
        }
        },
        // export excel chi tiet don
        async clickExportData2() {
            try {
                this.isLoadLinkDownload2 = true
                const params = {
                "isOnlyReturnable": false,
                "lastIndex": "",
                "queryString": this.search.queryString,
                "limit": 50000,
                "textSearch": this.search.textSearch,
                }
                const response = await OrdersService.exportDataROLineItems(params)
                console.log("data:::", response);
                if(response.success){
                this.clickExportDataMixin2(response.data, '/nsh/iex/api/order/download-file/')
                } else {
                this.$message.warning('Máy chủ đang bận. Hãy thử lại sau. ')
                }
            } catch (error) {
                this.$message.warning('Máy chủ đang bận. Hãy thử lại sau. '+ error)
            }
        },
        }
}
</script>

<style>
.main-content-layout {
    margin: 20px 0;
}

  .input-search {
    top: 0;
    width: 300px;
    padding: 0 0 10px 0;
  }

.btn-filter * {
}

.empty-return-table {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.empty-return-table h3 {
    width: 418px;
    height: 35px;
    font-weight: 600;
    font-size: 28px;
    line-height: 35px;
    margin-top: 20px;
    color: #DDDDDD;
}

.bottom-pagination {
    display: flex;
    justify-content: flex-end;
}

.loading-btn {
    margin-left: 30px;
}

.payment-info {
    width: 750px;
    background: #F2F3F4;
    margin: 15px 2px;
    padding: 4px;
    border: 1px solid #DDDDDD;
    border-radius: 8px;
    line-height: 160%;
}

.payment-info div {
    border-bottom: 1.5px solid #DDDDDD;
    margin: 0 -4px;
    padding: 8px 0;
}

.payment-info div:last-child {
    border: none;
}

.payment-status {
    display: flex;
    justify-content: center;
}

.payment-status div:nth-child(2){
    padding: 0 10px;
}

.payment-status span {
    margin-left: 10px;
}

.total-paid-amount-left span {
    color: red;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
}

.total-paid-amount-left span:first-child {
    color: black;
}
</style>

<style lang="scss">
.orders-success {
    .el-dialog__header {
        padding: 20px   ;
    }
    .el-dialog__body {
        padding: 10px 20px;
    }
}
</style>